/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_ClosedInputs */

const en_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const fr_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermee`)
};

const de_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlossen`)
};

const it_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiuso`)
};

const ru_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыто`)
};

const es_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrado`)
};

const zh_cn2_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉鎖`)
};

const hi_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद किया हुआ`)
};

const pt_pt2_manual_qc_status_closed = /** @type {(inputs: Manual_Qc_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechado`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Manual_Qc_Status_ClosedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_closed = /** @type {((inputs?: Manual_Qc_Status_ClosedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_ClosedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_status_closed(inputs)
	if (locale === "de") return de_manual_qc_status_closed(inputs)
	if (locale === "it") return it_manual_qc_status_closed(inputs)
	if (locale === "ru") return ru_manual_qc_status_closed(inputs)
	if (locale === "es") return es_manual_qc_status_closed(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_status_closed(inputs)
	if (locale === "ja") return ja_manual_qc_status_closed(inputs)
	if (locale === "hi") return hi_manual_qc_status_closed(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_status_closed(inputs)
	return en_manual_qc_status_closed(inputs)
});